import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Pushes a virtual page_view event to GTM's dataLayer on every React Router
 * navigation. Required because React is a SPA — the browser doesn't fire a
 * real page load between routes, so GA4 wouldn't otherwise see them.
 *
 * Place <RouteTracker /> once inside the Router; it has no UI.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
